import { render, staticRenderFns } from "./DemoApp.vue?vue&type=template&id=c1a36356&"
import script from "./DemoApp.vue?vue&type=script&lang=js&"
export * from "./DemoApp.vue?vue&type=script&lang=js&"
import style0 from "./DemoApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cbmsc/Projetos/fullcalendar-example-projects/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1a36356')) {
      api.createRecord('c1a36356', component.options)
    } else {
      api.reload('c1a36356', component.options)
    }
    module.hot.accept("./DemoApp.vue?vue&type=template&id=c1a36356&", function () {
      api.rerender('c1a36356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/DemoApp.vue"
export default component.exports